var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.563 6.537H25V.503H3.708C2.028.503.667 1.853.667 3.52v16.593h3.041c0 2.497 2.046 4.526 4.563 4.526s4.562-2.029 4.562-4.526h9.125c0 2.497 2.046 4.526 4.563 4.526s4.562-2.029 4.562-4.526h3.042v-7.542l-4.563-6.034zM8.27 22.377a2.269 2.269 0 01-2.281-2.264 2.269 2.269 0 012.28-2.262 2.269 2.269 0 012.282 2.262 2.269 2.269 0 01-2.281 2.263zM28.802 8.8l2.989 3.77H25V8.8h3.802zm-2.281 13.576a2.27 2.27 0 01-2.282-2.263 2.27 2.27 0 012.282-2.262 2.269 2.269 0 012.281 2.262 2.269 2.269 0 01-2.281 2.263z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadIconWhite);
export default __webpack_public_path__ + "static/media/load-icon-white.ba127aefb462ba564279fe1c2d0eb1ce.svg";
export { ForwardRef as ReactComponent };